import { CreateCourseFinanseRequest, courseFinancesApi } from "api/course-finances";
import React, { useState } from "react";

import { useToaster } from "utils";
import { CourseFinanceFormValues } from "../CourseFinances/CourseFinanceForm/CourseFinanceForm";
import { CreateCourseFinanceModal } from "./CreateCourseFinanceModal/CreateCourseFinanceModal";

import { BalancePieChart } from "pages/CourseFinances/BalancePieChart";
import { queryClient } from "main";
import { QUERIES_KEYS } from "queries";
import { useNavigate } from "react-router-dom";
import { routes } from "consts";

interface CourseFinancesProps {
  courseId: number;
}

export const CourseFinances = ({ courseId }: CourseFinancesProps) => {
  const { showSuccess } = useToaster();
  const navigate = useNavigate();
  const [modalItem, setModalItem] = useState<CourseFinanceFormValues | null>(null);

  const onSubmit = async (data: CreateCourseFinanseRequest) => {
    try {
      await courseFinancesApi.create(courseId, data);
      data.value > 0 ? showSuccess("Dodano koszt") : showSuccess("Dodano wydatek");
      setModalItem(null);
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.COURSE_FINANCES_BY_CATEGORIES(courseId) });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <BalancePieChart
        courseId={courseId}
        className="col-span-9 md:col-span-4"
        headerLink={routes.COURSES_MANAGE_NESTED.FINANCES(courseId)}
        onAdd={() => setModalItem({} as CourseFinanceFormValues)}
      />

      <CreateCourseFinanceModal
        isOpen={modalItem !== null}
        onCloseRequest={() => setModalItem(null)}
        onSubmit={onSubmit}
        courseId={courseId}
      />
    </>
  );
};
